export default {
  not_localised: 'Este documento ainda não está disponível na sua região. A mostrar a versão em inglês.',
};
